module.exports = __webpack_public_path__ + "img/ah07.fd995bf3.jpg";